import Crud from '../views/Suspicion/Crud'
import Entity from '../views/Suspicion/Add'

let routes = {
    path: '/suspicions',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/suspicions/add',
            name: 'NewRazaoEntrada',
            component: Entity,
            meta: {
                pageTitle: 'Suspeita',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Adicionar Suspeita',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/suspicions/edit/:id?',
            name: 'EditRazaoEntrada',
            component: Entity,
            meta: {
                pageTitle: 'Suspeita',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Editar Suspeita',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/suspicions',
            name: 'list-suspicions',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Suspeitas',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Suspeitas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
